module.exports = __webpack_public_path__ + "img/Proempresa.ec6cb38b.svg";